//messages.js
export default {
    // FE PARTS
    part_id: "Part #",
    name: "Name",
    model_number: "Model Number",
    mfg_id: "Mfg",
    vendor_id: "Vendor",
    file_id: "File",
    lead_time: "Lead Time",
    weight_pounds: "Weight Pounds",
    sales_price: "Sales Price",
    sales_unit: "Sales Unit",
    part_cost: "Part Cost",
    barcode: "Barcode",
    shipping_carrier_id: "Shipping Carrier",
    active: "Active",
    archive: "Archive",
    edit_part: "Edit Part",
    add_part: "Add Part",
    delete_part: "Delete Part",
    parts: "Parts",
    edit_fe_part: "Edit Part",
    add_fe_part: "Add Part",
    delete_fe_part: "Delete Part",
    delete_fe_part_confirm: "This action is not reversible!",
    delete_fe_part_image: "Delete Part Image",
    delete_fe_part_image_confirm: "This action is not reversible!",
    track_inventory: "Track inventory for this item",
    preferred_vendor_id: "Preferred Vendor",
    purchase_account_id: "Account",
    purchase_sku: "SKU",
    purchase_description: "Description",
    purchase_unit: "Purchase Unit",
    purchase_unit_weight: "Weight",
    sales_account_id: "Account",
    sales_sku: "Sales SKU",
    vendor_sku: "Vendor SKU",
    sales_description: "Description",
    sales_unit_weight: "Weight",
    sales_markup: "Markup",
    is_taxable: "Taxable",
    stock_quantity: "Quantity in Stock",
    order_quantity: "Quantity on Order",
    web_url: "Web URL",
    hts_code: "HTS Code",
    part_assembly: "Part Assembly",
    inventory_account_id: "Inventory Account",
    opening_stock: "Opening Stock",
    reorder_point: "Reorder Point",
    stock_bin_number: "Stock Bin Number",
    rate_per_unit: "Rate Per Unit",
    is_raw_material: "Raw Material",
    is_non_stock: "Non Stock Item",
    unit_of_measure_id: "Unit of Measure",
    add_another_vendor: "Add Vendor",
    no_vendors: "There are no Vendors added to this Part",
    unable_to_remove_prime_vendor: "Unable to remove Prime Vendor",
    categories: "Categories",
    reorder_quantity: "Reorder Quantity",
    is_service: "Service",
    cost_per_unit: "Cost Per Unit",
    mark_as_active: "Mark as Active",
    mark_as_inactive: "Mark as Inactive",
    on_hand: "On Hand",
    on_order: "On Order",
    exact_match: "Exact Match",
    old_control_number: "Old Control Number",
    is_global: "Global",
};
